<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="ISGprofile"
      :items="ISGprofile"
      :fields="ISGprofileFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="selectedISGprofile"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      ISGprofileFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      selectedISGprofile: null,
      options: {
        isShowAddButton: true
      },
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedISGprofile = {
        name: '',
        id: 0,
        lease_address: false,
        session_time: 5,
        static_password: '',
        login_type: 1,
        password_type: 1,
        unblocked_account_code: 2,
        blocked_account_code: 3,
        switch_type_id: 1,
        is_enabled_sir: false,
        send_coa: true
      }
      this.$root.$emit('bv::show::modal', 'modalEditISGprofileSettings', '#btnShow')
    },
    editItem (item) {
      this.selectedISGprofile = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditISGprofileSettings', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "ISG profile"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_ISG_PROFILE', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_ISG_PROFILE')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    ISGprofile () {
      return this.$store.getters['Settings/ISG_PROFILE']
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_ISG_PROFILE')
    this.$store.dispatch('Inventory/GET_SWITCH_TYPES')
    this.$store.dispatch('Tariffing/GET_SERVICES')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/network/ISGprofile/main.vue